<template>
<div class="main-content clearfix position-relative">
        <ContractorHeader :showroom="showroom" :isVisible="isVisible"></ContractorHeader> 
        <router-view :categories="showroom.category" :showroom_name="showroom_name" :business_logo="business_logo"  :phone_no="phone_no" :web_site="web_site" :isVisible="isVisible"></router-view> 
    </div>
</template>

<script>

import {mapActions,mapGetters} from 'vuex'
import axios  from "axios"; 
import Loading from '../../components/Loading.vue'



const ContractorHeader = () => ({
    component: import('../ContractorHeader.vue'),
     loading:Loading,
    timeout: 3000
})

 




export default {

    metaInfo() {
    return {
       // title: 'Royal construction Shop',
        meta: [ 
        {
            vmid: 'canonical',
            rel: 'canonical',
            href: window.location.origin + this.$route.fullPath
        }
        ]
    };
    },

 components:{  
     ContractorHeader, 


 },
    data(){
        return{
            isVisible:false,
            categoryList:[],
            subCategory:[],
            heading:'Appliances',
            currentUrl: window.location.href,
            profile:[],
            selectedCategory:'',
            showroom:'',
            shop_id:this.$route.params.vsd_id,
            showroom_name:'Showroom',
            business_logo:'',
            phone_no:'',
            web_site:''
        }
    },

    computed:{

        ...mapGetters({
            // 'showroom':'Common/ShowRoom',
            showroomId:'Common/MyItem',
            category:'Common/Category',
            ProductCategory:'Common/ProductCategory',
            TopProduct:'Common/TopProduct',
            ParentCategory:'Common/ParentCategory',
            SubCategory:'Common/SubCategory'

        })
    },
    methods:{
        ...mapActions('Common',
            ['updateNewLayout','updateMyItem' ]),
 
 

    },

    mounted() { 

        this.$root.$on('toogle_showroom', (x) => {
            console.log('x=',x);
            this.isVisible = x?false:true
        })

        let loader = ''
        loader = this.$loading.show({
            container: this.$refs.search_tab,
        });
        axios.get("/api/visualization/shop_profile", {
            params: {
                showroom: this.showroomId.showroom,
                vsd_id:shop_id,
                all_cat: 1
            }
        }).then((res)=>{
            loader.hide();
            this.showroom=res.data.data
          this.showroom_name=  this.showroom && this.showroom.profile && this.showroom.profile.company_name? this.showroom.profile.company_name: 'ShowRoom'
          this.business_logo=  this.showroom && this.showroom.profile && this.showroom.profile.business_logo? this.showroom.profile.business_logo: ''
          this.phone_no=  this.showroom && this.showroom.profile && this.showroom.profile.phoneno? this.showroom.profile.phoneno: ''
          this.web_site=  this.showroom && this.showroom.profile && this.showroom.profile.shop_website? this.showroom.profile.shop_website: ''
            this.updateMyItem({
                showroom: res.data.data.profile.user_id,
                vsd_id:this.shop_id,
                theme_color:res.data.data.profile.theme_color,
                custom_addon:res.data.data.profile.custom_addon?res.data.data.profile.custom_addon.subscription_status:false,
                basic_addon:res.data.data.profile.basic_addon?res.data.data.profile.basic_addon.subscription_status:false,
                showroom_name:this.showroom_name
            });
            let categoryList=this.category.list.length>0 ? this.category.list:res.data.data.category 

        }).catch((error)=>{ 
            loader.hide(); 
        })  
        this.updateNewLayout('Yes'); 
        loader.hide();  
    },



}
</script>
